import RequestAbstract from "../abstract";

export default class AccountingSystemTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-system-transactions";
    }

}
